import { Button } from "@heroui/react";
import { LimeTooltip } from "./LimeTooltip";

type ActionProps = {
  leftSection?: React.ReactNode;
  text: string;
  onClick: () => void;
  active?: boolean;
  identifier?: string;
};

export type LimeInputLabelProps = {
  label?: React.ReactNode;
  toolTip?: string;
  action?: ActionProps | React.ReactNode;
  htmlFor?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isActionProps = (action: any): action is ActionProps => {
  return action?.text !== undefined && action?.onClick !== undefined;
};

export const LimeInputLabel = ({
  label,
  toolTip,
  action,
  htmlFor,
}: LimeInputLabelProps) => {
  const finalLabel =
    typeof label !== "string" ? (
      label
    ) : (
      <label htmlFor={htmlFor} className="text-sm font-medium">
        {label}
      </label>
    );

  const finalAction = isActionProps(action) ? (
    <Button
      variant="flat"
      onPress={action.onClick}
      size="sm"
      className="w-fit rounded-xl"
      startContent={action.leftSection}
      color={
        action.active != null
          ? action.active
            ? "primary"
            : "secondary"
          : undefined
      }
      data-identifier={action.identifier}
    >
      {action.text}
    </Button>
  ) : (
    action
  );

  return (
    <>
      {(finalLabel || finalAction) && (
        <div className="mb-2 flex w-full items-center justify-between">
          <div className="flex items-center">
            {finalLabel}
            <LimeTooltip label={toolTip} />
          </div>
          {finalAction}
        </div>
      )}
    </>
  );
};
